const basedUrl = "http://localhost:5000/api"
export default basedUrl